function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1192_395)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.1704 3.73828H12.1704C7.75213 3.73828 4.17041 7.32 4.17041 11.7383V28.7383C4.17041 33.1566 7.75213 36.7383 12.1704 36.7383H29.1704C33.5887 36.7383 37.1704 33.1566 37.1704 28.7383V11.7383C37.1704 7.32 33.5887 3.73828 29.1704 3.73828Z",
  fill: "#3D50B0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7734 26.9252C18.3124 26.9252 17.8524 26.7502 17.5004 26.3982L11.5224 20.4202C10.8194 19.7172 10.8194 18.5772 11.5224 17.8742C12.2254 17.1722 13.3654 17.1722 14.0684 17.8742L18.7734 22.5802L27.2724 14.0812C27.9764 13.3792 29.1164 13.3792 29.8184 14.0812C30.5214 14.7842 30.5214 15.9242 29.8184 16.6272L20.0464 26.3982C19.6944 26.7492 19.2344 26.9252 18.7734 26.9252Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1192_395"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(0.67041 0.238281)"
})));

function SvgPaymentcheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentcheck);
export default __webpack_public_path__ + "static/media/paymentcheck.832783d3.svg";
export { ForwardRef as ReactComponent };